import * as Yup from 'yup';

export const instructions = Yup.string().max(
  500,
  'Your instructions should be less than 500 symbols',
);
